import * as yup from 'yup'

export const validateUpdateDiscountCode = yup.object().shape({
    status: yup
    .string()
    .oneOf(['active', 'inactive', 'pending security verification', 'pending user data', 'pending validation'], 'Debes elegir entre estas opciones'),
    name: yup
    .string()
    .min(3, 'El NOMBRE debe tener más de 2 caracteres'),
    code:yup
    .string()
    .min(2, 'El CÓDIGO debe tener más de 2 caracteres'),
    quantity:yup
    .number().typeError('Campo requerido.')
    .positive()
    .min(0, 'Debe de utilizar un numero que no sea negativo'),
    // value_percentage:yup
    // .number().typeError('Campo requerido.')
    // .positive()
    // .min(0, 'Debe de utilizar un numero que no sea negativo'),
    // value_amount:yup
    // .number().typeError('Campo requerido.')
    // .positive()
    // .min(0, 'Debe de utilizar un numero que no sea negativo'),
    uses_by_user:yup
    .number().typeError('Campo requerido.')
    .positive()
    .min(0, 'Debe de utilizar un numero que no sea negativo'),
    order_min_amount:yup
    .number().typeError('Campo requerido.')
    .positive()
    .min(0, 'Debe de utilizar un numero que no sea negativo'),
    date_start: yup
    .date(),
    date_end: yup
    .date(),
})